"use strict";

module.exports = {
  buttons: {
    backLink: "BACK",
    cancelButton: "CANCEL",
    chatWithAgentButton: "CHAT WITH AN AGENT",
    closeButton: "CLOSE",
    contactSupportButton: '<a href="" class="adsktm-show-contact-support-btn">CONTACT SUPPORT</a>',
    copiedButton: "COPIED",
    copyButton: "COPY",
    getStartedButton: "GET STARTED",
    haveAQuestion: "Have a question?",
    helpPanel: '<a target="_blank" href="https://knowledge.autodesk.com/contact-support/installation-activation/activation-registration">HAVE A QUESTION?</a>',
    nextButton: "NEXT",
    requiredLabel: "Required",
    restartButton: "RESTART",
    signInButton: "SIGN IN",
    submitAgainButton: "SUBMIT AGAIN",
    submitButton: "SUBMIT",
    tryAgainButton: "TRY AGAIN",
    notNow: "NOT NOW",
    validate: "VALIDATE"
  },
  signIn: {
    gatheringInfo: "Gathering your account information",
    helloUser: "Hello, <first-name>!",
    justAMoment: "Just a moment ...",
    signInNow: "<a>Sign in now</a>",
    signInHelp: '<a target="_blank" href="https://knowledge.autodesk.com/contact-support/account-management/account-creation-sign-profile-management">Having trouble signing in?</a>',
    startAccessAccount: "Let’s start with accessing your account."
  },
  contactOptions: {
    addtlComments: "Description (optional)",
    addtlCommentsMsg: "Tell us any details we should know.",
    addtlCommentsReqd: "Description",
    agentAvailable: "Agent available",
    agentAvailableStdby: "Agent is available - stand by",
    agentUnavailable: "Agent unavailable",
    cancelCase: "CANCEL CASE",
    cancelChat: "CANCEL CHAT",
    caseConfirm1: "You will receive an email confirmation shortly. If you do not receive an email, check your email junk/spam folder.",
    caseConfirm2: "An agent will review your case and get back to you within 2 business days.",
    caseDetails: "Case details",
    caseNumber: "Case number: <case-number>",
    caseSubmitted: "Case submitted",
    chatWithAgent: "Chat with an agent",
    closingWindowMsg: "Closing this window before you’re connected may cancel the chat",
    connectMomentarily: "You will be connected momentarily.",
    createCase: "Create a case",
    errorLabel: "Error",
    forceStartChat: "<a>Click here to start the chat.</a>",
    getCaseAnswer2Days: "Get an answer within 2 days",
    mayCloseWindow: "You may close this window now.",
    note: "NOTE:",
    orSubmitCase: "Or <a>submit a case</a> and someone will get back to you within 2 business days.",
    popUpBlocker: "Have a pop-up blocker?",
    productLabel: "Product",
    sorryNoAgent: "Sorry, agent is unavailable",
    willUpdateAgent: "We will update this screen as soon as an agent becomes available.",
    yourContactInfo: "Your contact information"
  },
  welcome: {
    important: "Important:",
    noteForTheUser: "Note:"
  },
  captchaScreen: {
    correctMsg: "Correct!",
    incorrectMsg: "Incorrect. Try again.",
    pageTitle: "Security check",
    typeCaptchaLabel: "Enter the characters you see above"
  },
  contactInfoScreen: {
    emailDisclaimer: "We need this to send you a confirmation.",
    emailTitle: "Email",
    firstNamePlaceholder: "First name",
    lastNamePlaceholder: "Last name",
    nameLabel: "Name",
    pageTitle: "1. Your contact information"
  },
  reviewAccountInfo: {
    differentAccount: "<a>Sign into a different account</a>",
    emailConfirm: "We will use this email to pull up your account and send you a confirmation.",
    helloUser: "Hello <first-name>!",
    pageTitle: "1. Review your account information",
    signedInAs: "You are signed in as:"
  },
  processInfoScreen: {
    checkSerialMsg: "To check this serial number, press Enter.",
    continueTyping: "Continue typing a serial number with this format: XXX-XXXXXXXX.",
    doNotNeedHula: "<strong>Good news!</strong> You don't need to request a separate home use license. You can install and activate the software on a home computer using the same serial number.",
    downloadYourProduct: "Download your product and install it. Additional activation will not be necessary.",
    emailForSerialNumPlaceholder: "Email associated",
    emailForSerialNumTitle: "Email associated with serial number",
    emailForSerialNumTooltip: "This is the email address of the software coordinator, contract manager or person who purchased the software",
    ineligiblePerpetual: 'This serial number is for a perpetual license that is <b>not eligible</b> for home use.<br/><br/>Our software subscriptions are available for use anytime, anywhere. <a target="_blank" href="https://www.autodesk.com/subscription">Find out more about subscription benefits</a>.',
    justTypeIn: "- If your serial number isn't listed, try typing it in. -",
    msgEducationSerialNum: "This is an education serial number.",
    msgGoToEducationComm: '<a target="_blank" href="https://www.autodesk.com/education/free-software/all">Go to Education Community</a>',
    msgIndustryCollectionSerialNum: "This serial number is part of a collection: <collection-name>",
    msgNetworkSerialNum: "This serial number is for a <Strong>network license</Strong> and you don’t need an activation code. Please contact your Network Administrator to verify that your license is set up correctly.",
    msgSubscriptionSoftware: 'This serial number is for <Strong>subscription software</Strong> and you don’t need an activation code. Please launch your product while you are connected to the internet. Then just <a target="_blank" href="https://knowledge.autodesk.com/article/subscriber-activation">sign in</a> or <a target="_blank" href="https://knowledge.autodesk.com/article/online-activation-registration">enter a serial number</a>.',
    msgBiCIndirectSoftware: "You no longer need an activation code because your license is now part of our improved account experience. Just sign in using your Autodesk email and password to start using the software (make sure you are connected to the internet).",
    msgBicIndirectSCRole: '"The software coordinator role is not included with your license. For more information, see <a target="_blank" href="https://knowledge.autodesk.com/customer-service/account-management/users-software/classic-user-management/hybrid-admin-roles">User management admin roles</a>."',
    msgBicIndirectCMRole: 'Changing the contract manager does not change the primary admin. You can assign that role in Autodesk Account (see <a target="_blank" href="https://knowledge.autodesk.com/customer-service/account-management/users-software/user-management/primary-admins">Primary Admins</a>).',
    msgSN2010orOlder: 'The serial number you entered is for an older version that is no longer supported. <a target="_blank" href="https://knowledge.autodesk.com/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">See eligibility requirements</a>',
    myProductNotListed: "My product isn't listed",
    noResultsMsg: "No results found. Enter a serial number with this format: XXX-XXXXXXXX.",
    pageTitle: "2. Product information",
    partOfCollection: "Your product is part of this collection: <collection-name>",
    requestCodeTitle: "Request code",
    requestCodetooltip: 'How to find your <a target="_blank" href="https://www.autodesk.com/find-request-code-eng">request code</a>',
    selectPlaceholder: "Select",
    selectProduct: "Select your specific product",
    selectProductPlaceholder: "Select product",
    selectYourProductTitle: "Select your product",
    serialNumberLabel: "Serial number",
    serialNumberPlaceholder: "Search by name - or - type a number",
    serialNumbersInAccount: "SERIAL NUMBERS IN YOUR ACCOUNT",
    serialNumberTooltip: 'How to find your <a target="_blank" href="https://www.autodesk.com/find-serial-number-eng">serial number</a>',
    yesOption: "Yes",
    noOption: "No",
    currentInfoTitle: "2. Current information",
    contractNumDisclaimer: "Include the hyphen (-) if your contract number has one.",
    contractNumLabel: "Contract number",
    contractNumTooltip: 'Find the contract number in the Billing & Orders area in your <a target="_blank" href="https://manage.autodesk.com">Account.</a>'
  },
  authorizationRequestScreen: {
    enterEmail: "Enter email",
    option1: "I confirm that I’m the administrator, contract manager, or software coordinator for this product.",
    option2: "I confirm that I’m making this request on behalf of the administrator, contract manager, or software coordinator and their email is:",
    pageTitle: "3. Authorization for this request",
    selectOne: "Please select one"
  },
  processingScreen: {
    firstMsg: "Working on your request",
    takingLongerExpected: "It's taking longer than expected - sorry for the wait.",
    updatedMsgLonger: "Still working on it",
    willTakeSecs: "This might take a few seconds…"
  },
  successScreen: {
    expirationLine: "<br/>Expiration date: <expiration-date>",
    infoWillBeEmailed: "This information will also be emailed to you at: <email>",
    pageTitle: "Success",
    prodSeatMulti: "<product-name> (for <number-seats> seats)<br/>",
    prodSeatSingle: "<product-name> (for 1 seat)<br/>",
    pvApprovedMsg: "Your previous version request has been approved.",
    pvInstruction: "Install and activate your software using the following information.",
    reponseText: "Your activation code is: <activation-code>",
    responseText1: "Your home use license request was approved.",
    responseText2: "Install and activate your software using the following information. Select “stand-alone” during installation.",
    responseText3: "Serial number: <serial-number><br/>Product key: <product-key>",
    updateDisclaimer: "Please allow a few hours for the change to appear in your account."
  },
  errors: {
    emailNotAssocWithSerialNumber: "This email isn't associated with this serial number.",
    enterCMSCEmail: "Enter the email for the contract manager or software coordinator for this product",
    enterComments: "Enter a description",
    enterEmail: "Enter your email",
    enterEmailAssociated: "Enter the email associated",
    enterFirstName: "Enter your first name",
    enterLastName: "Enter your last name",
    enterRequestCode: "Enter your request code",
    enterSerialNumber: "Enter your serial number",
    enterValidFormat: "Enter a valid format",
    invalidAutodeskSerialNumber: '<p>This is not a valid Autodesk serial number.</p><p>Please make sure that you are using software purchased from authorized sources:</p><ul><li><a target="_blank" href="http://www.autodesk.com/store">Autodesk Store</a></li><li><a target="_blank" href="http://www.autodesk.com/resellers/locate-a-reseller">Authorized Resellers</a></li><li><a target="_blank" href="https://www.autodesk.com/education/prepare-and-excel/authorized-academic-partner">Education Partners</a></li></ul>',
    invalidLicenseModel: "This product has an an invalid license model.",
    invalidRequestcode: "Invalid request code",
    invalidSerialNumber: "Invalid serial number",
    notCMSC: "Our records indicate that you aren’t the contract manager or software coordinator for this product.",
    oops: 'Sorry, something went wrong while processing your request. <a target="_blank" href="" class="adsktm-show-contact-support-btn">Contact Support</a>',
    overActivation: "Over-activation",
    productExpired: "The product you are trying to activate has expired.",
    reasonForActivation: "Reason for activation",
    serialNumNotAssocWithSingleLicense: "This serial number isn't associated with a single-user license.",
    serialNumNotFound: "Serial number not found",
    serialNumNotRegisteered: 'This serial number hasn\'t been registered yet. Please <a target="_blank" href="http://registeronce.autodesk.com/">register</a> it first.'
  },
  requestFailedScreen: {
    caseError: "Sorry, something went wrong while submitting your case.",
    contactOptionsBelow: 'If you need help, <a id="go-to-contact-us" href="javascript:void(0);">contact us</a> using an option below.',
    expiredSubsTitle: "Expired subscription",
    expiredSubscription: "Your request can\u2019t be completed because your subscription has expired. Please check with your account administrator or check your <a target=\"_blank\" href=\"https://manage.autodesk.com/cep/#products-services\">account</a> for renewal options.",
    inactiveSubsTitle: "Inactive subscription",
    noActiveSubs: "Your request can\u2019t be completed because your subscription is not yet active or has expired. Please check with your account administrator\t or check your <a target=\"_blank\" href=\"https://manage.autodesk.com/cep/#products-services\">account</a> for renewal options.",
    pageTitle2: "Request can't be completed",
    pageTitle: "Request failed",
    prodNotEligibleTitle: "Product not eligible",
    prodNotRegisteredTitle: "Product not registered",
    prodNotRegistered: "Your request can't be completed because your product hasn't been registered yet.<br><br><a target=\"_blank\" href=\"https://registeronce.autodesk.com\">Register your product</a>",
    responseText: "Sorry, something went wrong while processing your request."
  },
  gac: {
    welcome: {
      clickGetStarted: "Click Get Started to get an activation code.",
      modalTitle: "Get activation code",
      noteBullet1: "You need an activation code only if you have a stand-alone perpetual license or a stand-alone education license (student or educator) and <strong>no Internet access.</strong>",
      noteBullet2: '<strong>If you have Internet access, you don’t need an activation code.</strong> Just start your product and follow the instructions for <a target="_blank" href="https://www.autodesk.com/sign-in-activation-eng">signing in</a> or <a target="_blank" href="https://www.autodesk.com/access-with-serial-number-eng">entering a serial number.</a>'
    },
    signInOptional: {
      title: "Sign in (optional)",
      message: "It\u2019s easier if you sign in, but you don\u2019t have to."
    },
    overActScreen: {
      actAgainLabel: "Select a reason for activating again",
      pageTitle: "3. Reason for over-activation",
      reason1: "New computer",
      reason2: "Computer stolen",
      reason3: "Software reinstalled",
      reason4: "Other",
      responseText: "This serial number has been activated before.",
      selectReason: "Select a reason"
    },
    requestFailedScreen: {
      gacExportControlBlock: 'Your eligibility to use Autodesk products is currently undergoing standard export screening which usually takes a few minutes. Please try again shortly. For more information see the Autodesk <a target="_blank" href="https://www.autodesk.com/company/legal-notices-trademarks/compliance">Export Compliance policy.</a>',
      gacProductKeyAndSerialNotFound: 'We couldn’t find a matching product. Make sure you entered the correct serial number. For more information, see <a target="_blank" href="https://knowledge.autodesk.com/customer-service/download-install/activate/find-serial-number-product-key">Find serial number & product key.</a>',
      gacAssetNotFound: 'Make sure you entered the serial number correctly. If this is a recently purchased product, allow more time for processing. See <a target="_blank" href="https://knowledge.autodesk.com/customer-service/download-install/download/subscription-downloads#missing">Don’t see your product?</a> for more information.',
      gacContactNotFound: "Email not found. Make sure you entered the correct email address for this serial number.",
      gacGetAssetActivationCode: "Something went wrong. Click <b>Submit Again</b>. If that doesn’t work after a few attempts, contact support.",
      gacFlexShortRequestCodeInvalid: "This is not a valid request code. Make sure you entered the code correctly."
    }
  },
  hula: {
    welcome: {
      clickGetStarted: "Click Get Started to get your home use serial number.",
      intro: "Follow these quick steps to get a home use license.",
      modalTitle: "Request a home use license",
      noteBullet1: 'Home use is available for <a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-eng">eligible products</a> on multi-user subscriptions and network licenses on maintenance plans.',
      noteBullet2: "Single-user subscriptions automatically include home use. You can install and activate the software on a home computer using the same serial number."
    },
    processInfoScreen: {
      hulaEligibleVersionMsg: 'Only eligible versions are listed above. <a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-eng">See eligibility requirements</a>',
      crossGradeHulaMessage: "We can't process your request here. To get a home use license for the selected version, please <a id=\"go-to-create-case\" href=\"javascript:void(0);\">create a case.</a> We will get back to you in 2 business days."
    },
    errors: {
      tokenFlexSerialNumber: "You\u2019ve entered a TokenFlex serial number. To request a home use license, please email your Autodesk Premier Expert at <strong><a href=\"mailto:premier@autodesk.com\">premier@autodesk.com</a></strong>."
    },
    requestFailedScreen: {
      hulaEligibilityReqs: '<a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-eng">See eligibility requirements</a>',
      hulaIneligible: "Your request can’t be completed because your product isn’t eligible for a home use license.",
      exportControlBlockOREmbergoList: "Your eligibility to use Autodesk products is currently undergoing standard export screening which usually takes a few minutes. Please try again shortly. For more information see the Autodesk <a href=\"https://www.autodesk.com/company/legal-notices-trademarks/compliance\">Export Compliance policy.</a>"
    }
  },
  pv: {
    welcome: {
      clickGetStarted: "Click Get Started to get access to a previous version of your software.",
      intro: "Follow these quick steps to get a previous version of your software.",
      modalTitle: "Request a previous version",
      noteBullet1: 'If you have a subscription, log into your <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">account</a> and download the previous version you need.',
      noteBullet2: 'If you have a stand-alone license on a maintenance plan, use this method to request previous versions of <a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-eng">eligible</a> products.'
    },
    processInfoScreen: {
      noPvAvailable: 'Previous versions of the product you requested are not available. See our <a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-eng">previous version policy</a> for more information.',
      pvEduUserMsg: 'You have an Educational license. Go to the <a target="_blank" href="https://www.autodesk.com/education/free-software/all">Education Community</a>, where you can download up to three previous versions.',
      pvEligibleVersionMsg: 'Only eligible versions are listed above. <a target="_blank" href="https://knowledge.autodesk.com/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">See eligibility requirements</a>',
      pvMultiUserSubsMsg: 'You have a multi-user subscription. Previous version serial numbers are displayed in your <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">account.</a>',
      pvNetworkMaintenanceUserMsg: 'You have a network license. Previous version serial numbers are displayed in your <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">account.</a>',
      pvPerpetualUserMsg: 'The perpetual license for this product does not include access to previous versions.<br/><br/>Subscriptions include previous version access. <a target="_blank" href="https://www.autodesk.com/subscription">Find out more about subscription benefits.</a>',
      pvSingleUserSubsMsg: 'You have a single-user subscription. To access to up to three previous versions, just specify which products you want in your <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">account.</a> (Look for the “Get a serial number” link.)',
      serialNumberCurrentLabel: "Current serial number",
      versionRequestingLabel: "Version you’re requesting"
    },
    errors: {
      tokenFlexSerialNumber: "You\u2019ve entered a TokenFlex serial number. To request a previous version license, please email your Autodesk Premier Expert at <strong><a href=\"mailto:premier@autodesk.com\">premier@autodesk.com</a></strong>."
    },
    requestFailedScreen: {
      pvEligibilityReqs: '<a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-eng">See eligibility requirements</a>',
      pvInactiveSubscription: 'Your request can’t be completed because your subscription for this product is no longer active in your <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">account.</a>',
      pvIneligible: "Your request can’t be completed because your product isn’t eligible for a previous version license."
    }
  },
  cm: {
    welcome: {
      clickGetStarted: "Click Get Started to change your contract manager.",
      modalTitle: "Change contract manager",
      noteBullet1: "You can change the contract manager for maintenance plans and subscriptions that are not auto-renewing.",
      noteBullet2: "If you have an auto-renewing subscription, you will have to cancel the subscription and start a new one to change the contract manager."
    },
    processInfoScreen: {
      cmEmailPlaceholder: "Associated with the contract number",
      currentCmEmailLabel: "Current contract manager’s email",
      newCmEmailLabel: "New contract manager’s email",
      newCmNameLabel: "New contract manager’s name",
      newCmPhoneLabel: "New contract manager’s phone number",
      pageTitle2: "3. New information",
      phoneNumPlaceholder: "Include area code and number"
    },
    authorizationRequestScreen: {
      option1: "I confirm that I am the contract manager or have been given the appropriate authority from the company that owns this subscription to make this request.",
      confirmLabel: "Please confirm that you are authorized to make this request",
      pageTitle: "4. Authorization for this request"
    },
    successScreen: {
      cmWillReceiveEmail: "The new contract manager will get an email with more instructions.",
      emailWillBeSent: "You will receive an email confirmation at: <email>",
      responseText4: "Contract number <contract-number> has a new contract manager:"
    },
    errors: {
      contractNumNotFound: "Contract number not found",
      emailNotAssociatedWithcontractNum: "This email isn’t associated with the contract number above.",
      enterContractNum: "Enter your contract number"
    },
    requestFailedScreen: {
      autoRenewSubs: "Our records show that you have an auto-renewing subscription. To change the contract manager, you will have to cancel the subscription and start a new one.",
      autoRenewSubsTitle: "Auto-renew subscription",
      inactiveContract: "Your request can’t be completed because your contract is no longer active.",
      inactiveContractTitle: "Inactive contract",
      serialNumberIneligible: "Your request can’t be completed as your serial number isn’t eligible for a contract manager change.",
      serialNumberIneligibleTitle: "Serial number not eligible"
    }
  },
  sc: {
    welcome: {
      clickGetStarted: "Click Get Started to change your software coordinator.",
      modalTitle: "Change software coordinator",
      noteBullet1: "You can use this method to change the software coordinator for maintenance plans and subscriptions (except for education products)."
    },
    processInfoScreen: {
      currentScEmailLabel: "Current software coordinator’s email",
      newScEmailLabel: "New software coordinator’s email",
      newScNameLabel: "New software coordinator’s name",
      newScPhoneLabel: "New software coordinator’s phone number",
      scEmailPlaceholder: "Associated with the serial number",
      importantInformation: "Important information"
    },
    authorizationRequestScreen: {
      option1: "I confirm that I am the contract manager, software coordinator, or have been given the appropriate authority from the company that owns this subscription to make this request."
    },
    successScreen: {
      responseText4: "Serial number <serial-number> has a new software coordinator:",
      scWillReceiveEmail: "The new software coordinator will get an email with more instructions."
    },
    errors: {
      emailNotAssociatedWithSerialNum: "This email isn’t associated with the serial number above.",
      tokenFlexSerialNumber: "You've entered a TokenFlex serial number. To change the Software Coordinator, please email your Autodesk Premier Expert at <strong><a href=\"mailto:premier@autodesk.com\">premier@autodesk.com</a></strong>."
    },
    requestFailedScreen: {
      serialNumberIneligle: "Your request can’t be completed as your serial number isn’t eligible for a software coordinator change.",
      serialNumberIneligleTitle: "Serial number not eligible"
    }
  },
  ccna: {
    welcome: {
      clickGetStarted: "Click Get Started to change your company contact information.",
      modalTitle: "Change Company Name or Address",
      noteBullet1: "You can only change the company name and address <strong>if you are the Contract Manager.</strong>",
      noteBullet2: "<strong>This process will not transfer ownership.</strong> To transfer a license to a new owner, you must <a target=\"_blank\" href=\"https://knowledge.autodesk.com/customer-service/download-install/activate/transfer-licenses/transfer-ownership-licenses\">complete a Transfer of License Request</a>."
    },
    processInfoScreen: {
      reviewInfoTitle: "Review your account information",
      currentInfoTitle: "Current information",
      current: "Current: ",
      pageTitle2: "Enter New information",
      pageTitleValidateAddr: "Validate address",
      pageTitleConfirmChanges: "Confirm changes",
      changeInfoLabel: "What information would you like to change?",
      addressOption: "Address",
      nameOption: "Company name",
      nameAndAddressOption: "Both company name & address",
      newTaxIdLabel: "Do you also have a new tax ID or EIN",
      msgTOLS: "Based on your answers above, you must <a target=\"_blank\" href=\"https://knowledge.autodesk.com/customer-service/download-install/activate/transfer-licenses/transfer-ownership-licenses\"> complete a Transfer of License</a> to transfer a license to a new owner. If you need further assistance, <Strong>contact customer support below</Strong>",
      unauthorizedUser: "You are not authorized to make changes to this contract.",
      msgAutoRenew: "Company name or address changes for auto-renew recurring billing, and some cloud based software contracts cannot be made online. Please follow these steps to <a target=\"_blank\" href=\"https://knowledge.autodesk.com/customer-service/account-management/account-profile/change-company-name-and-address\">change your company name or address.</a>",
      msgExpiredContract: "This contract has expired.",
      notEligible: "This contract is not eligible.",
      changingInfoFor: "Changing info for contract #: <contract-number>",
      companyName: "Company name",
      accountCSN: "Account CSN",
      streetAddress: "Street address",
      city: "City",
      state: "State/Province",
      postalCode: "Postal code",
      country: "Country",
      validateAddDisclaimer: "Our best address match is highlighted below. Selecting the entered may result in additional processing time.",
      confirmDisclaimer: "Before submission, please review your changes for any error. You may return to the previous screen to any required edits.",
      recommendedAddr: "Best Address Match",
      enteredAddr: "Your Entered Address",
      changeWillbeAppliedFor: "Changes will be applied to contract #: <contract-number>",
      new: "NEW",
      old: "OLD",
      emailWillBeSent: "Email confirmation will be sent to:"
    },
    successScreen: {
      emailWillBeSent: "You will receive an email confirmation at: <email>",
      changeAppliedFor: "Contract # <contract-number> has been updated to the following:",
      nonCleansedAddrMsg: "You will receive an email confirmation shortly containing your Case Number. Please keep this email for your records.<br><br><strong>We will respond to your case within two business days.</strong><br><br>If you do not receive your confirmation email within one hour check your Junk email folder or contact your Network Administrator for further assistance."
    },
    errors: {
      contractNumNotFound: "Contract number not found",
      invalidContractNum: "Invalid contract number",
      enterContractNum: "Enter your contract number"
    }
  }
};